export const hiddenCommunitySlugs = ["readingrhythms"];
export const DEFAULT_EVENT_CAPACITY = 25;

export const DIALOG_VARIANTS = {
    hidden: { opacity: 0, y: -50 },
    visible: { opacity: 1, y: 0 },
};

export const RIVER_EMAILS = {
    SUPPORT: { name: "River Support", email: "help@getriver.io" },
    NOTIFICATIONS: {
        name: "River Notifications",
        email: "notifications@getriver.io",
    },
    HOST: { name: "Events on River", email: "host@getriver.io" },
    TEAM: { name: "The River Team", email: "hello@getriver.io" },
    COMMUNITY_MANAGER: {
        name: "Community Manager",
        email: "community_management@getriver.io",
    },
    INVITATIONS: {
        name: "River Invitations",
        email: "invitations@getriver.io",
    },
};

export const UNSAFE_CHARS_FOR_SLUGS: string[] = [
    " ",
    '"',
    "#",
    "%",
    "&",
    "/",
    ":",
    ";",
    "=",
    "?",
    "@",
    "+",
    "$",
    ",",
    "<",
    ">",
    "[",
    "]",
    "{",
    "}",
    "|",
    "\\",
    "^",
    "~",
    "`",
    "'",
];

export const URL_REGEX =
    /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;

let baseUrl: string =
    process.env.NODE_ENV === "development"
        ? "http://localhost:3000"
        : "https://app.getriver.io";

export const APP_URL = baseUrl;
// this always needs to be the prod url or shit is not gonna work ever
// (must be publicly accessible)
export const STRIPE_APP_URL = "https://app.getriver.io";

export const UPLOAD_TEMP_BUCKET_EVENT_IMAGE = "temp/event-proposal";

export const NAME_NOUNS: string[] = [
    "River",
    "Stream",
    "Rapids",
    "Brook",
    "Waterfall",
    "Eddy",
    "Current",
    "Spring",
    "Cascade",
    "Tide",
    "Lagoon",
    "Creek",
    "Basin",
    "Pool",
    "Delta",
    "Shore",
    "Drift",
    "Wave",
    "Bayou",
    "Confluence",
    "Whirlpool",
    "Estuary",
    "Tributary",
    "Swamp",
    "Pond",
    "Bay",
    "Mist",
    "Flood",
    "Droplet",
    "Lake",
];

export const NAME_ADJECTIVES: string[] = [
    "Flowing",
    "Raging",
    "Bubbling",
    "Meandering",
    "Murmuring",
    "Roaring",
    "Sparkling",
    "Glistening",
    "Swirling",
    "Serene",
    "Wandering",
    "Torrential",
    "Shimmering",
    "Churning",
    "Rapid",
    "Hidden",
    "Whispering",
    "Wild",
    "Cascading",
    "Tumbling",
    "Foamy",
    "Rippling",
    "Misty",
    "Still",
    "Silver",
    "Golden",
    "Tranquil",
    "Dancing",
    "Echoing",
    "Glacial",
];

const simpleHash = (str: string): number => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = (hash << 5) - hash + str.charCodeAt(i);
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
};

export const generateRandomName = (userId: string): string => {
    const hash = simpleHash(userId);
    const adjectiveIndex = Math.abs(hash) % NAME_ADJECTIVES.length;
    const nounIndex = Math.abs(hash >> 16) % NAME_NOUNS.length;

    const adjective = NAME_ADJECTIVES[adjectiveIndex];
    const noun = NAME_NOUNS[nounIndex];

    return `${adjective} ${noun}`;
};

export const generateRandomNames = (userIds: string[]): string[] => {
    return userIds.map(generateRandomName);
};

export const TEMPORARY_BUCKET_KEY = "tempBucket";

export const RATE_THRESHOLD = 4.2;

export const STRIPE_APP_METADATA = {
    APP_NAME: "river",
    APP_TYPE: "river_events_app",
};
